import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getIsProductCompareFull,
    getProductCompareChecked,
} from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import addProductToCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/AddProductToCompare";
import removeProductFromCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/RemoveProductFromCompare";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Share2 from "@insite/mobius/Icons/Share2";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import NISCompareIcon from "@tCentro/Icons/NISCompareIcon";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    // showCompare: boolean;
    showAddToList: boolean;
    extendedStyles?: NISProductDeatilsProductImageStyles;
}
const enum fields {
 showCompare = "showCompare",
    visibilityState = "visibilityState",
    icon = "icon",
    link = "link",
    includeAccountMenu = "includeAccountMenu",
}
interface OwnProps extends WidgetProps {
    fields: {
          [fields.showCompare]: boolean;
            [fields.visibilityState]: string;
                  [fields.icon]: string;
                  [fields.includeAccountMenu]: boolean;
                  [fields.link]: LinkFieldValue;
    }
}
const mapStateToProps = (state: ApplicationState, props: HasProductContext) => ({
    settingsCollection: getSettingsCollection(state),
    productCompareChecked: getProductCompareChecked(state, props.productContext),
    isProductCompareFull: getIsProductCompareFull(state),
});

const mapDispatchToProps = {
    addProductToCompare,
    removeProductFromCompare,
};

type Props = ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps &
    HasProductContext;

export interface NISProductDeatilsProductImageStyles {
    wrapper?: InjectableCss;
    productImage?: ProductImageStyles;
    compareCheckbox?: CheckboxPresentationProps;
    addToListWrapper?: InjectableCss;
    addToListLink?: ProductAddToListLinkStyles;
    productSaveCompareWrapper?: InjectableCss;
    productImageWrapper?: InjectableCss;
    saveLink?: InjectableCss;
    titleTypography?: TypographyPresentationProps;
}

export const nisProductImageStyles: NISProductDeatilsProductImageStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                    width: 45% !important;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
    compareCheckbox: {
        css: css`
            align-self: center;
            flex: 2;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 16px;
            span {
                height: 12px;
                width: 12px;
                min-width: 12px !important;
                border: 1px solid ${COLORS.background.tag} !important;
            }
            label {
                font-size: ${TYPOGRAPHY.size.tiny};
                margin-left: 5px !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-right:10px;
                    flex:none;
                `,
                css`
                    flex:1;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
    addToListWrapper: {
        css: css`
            display: inline-flex;
            flex: 1;
            // justify-content: flex-end;
            button > span > span {
                width: 16px !important;
                svg {
                    height: 10px !important;
                    width: 12px !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex:none;
                `,
                null,
                null,
                null,
                null,
            ])}
        `,
    },
    productSaveCompareWrapper: {
        css: css`
            display: flex;
            margin-bottom: 10px;
            gap:8px;
        `,
    },
    saveLink: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
            span {
                color: ${COLORS.background.tag};
                vertical-align: middle;
            }
        `,
    },
    titleTypography: {
                css: css`
                    margin-left: 0;
                    margin-top: 0;
                    color: ${getColor("primary")};
                    text-transform: capitalize;
                    font-size: ${TYPOGRAPHY.size.base};
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                    line-height: 16px;
                    font-family: Roboto Condensed;
                              @media (min-width: 1080px) and (max-width: 1340px) {
                        font-size: 12px;
                        font-weight: 700;
                    }
                    ${({ theme }) => {
        
                        return breakpointMediaQueries(theme, [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            css`
                                @media (min-width: 993px) and (max-width: 1079px) {
                                    display: none;
                                }
                            `,
                        ]);
                    }}
                `,
                // ellipsis: true,
                // transform: "uppercase",
            },
};

const NISProductDeatilsProductCompare: FC<Props> = ({
    productContext,
    fields,
    isProductCompareFull,
    settingsCollection,
    productCompareChecked,
    extendedStyles,
    addProductToCompare,
    removeProductFromCompare,
    showAddToList,
}) => {
    const toasterContext = React.useContext(ToasterContext);
    const [styles] = useState(() => mergeToNew(nisProductImageStyles, extendedStyles));

        const showIcon = fields.visibilityState === "both" || fields.visibilityState === "icon";
    const showLabel = fields.visibilityState === "both" || fields.visibilityState === "label";
    const handleChanged = (_: React.SyntheticEvent, value: boolean) => {
        if (value && isProductCompareFull) {
            toasterContext.addToast({
                body: siteMessage("ProductionCompare_MaximumItemsReached"),
                messageType: "warning",
            });
        } else if (value) {
            addProductToCompare({ productId: productContext.product.id });
        } else {
            removeProductFromCompare({ productId: productContext.product.id });
        }
    };
    const handleClick = () => {
  const nextValue = !productCompareChecked; // simulate toggle like checkbox

  if (nextValue && isProductCompareFull) {
    toasterContext.addToast({
      body: siteMessage("ProductionCompare_MaximumItemsReached"),
      messageType: "warning",
    });
  } else if (nextValue) {
    addProductToCompare({ productId: productContext.product.id });
  } else {
    removeProductFromCompare({ productId: productContext.product.id });
  }
};

    return (
        <StyledWrapper
            {...styles.wrapper}
            data-test-selector="productListProductCompare"
            data-test-key={productContext.product.id}
        >
            {/* <StyledWrapper {...styles.productSaveCompareWrapper}>
                {fields.showCompare && settingsCollection.productSettings.enableProductComparisons && (
                    <Checkbox
                        {...styles.compareCheckbox}
                        checked={productCompareChecked}
                        onChange={handleChanged}
                        data-test-selector="productList_CompareCheckbox"
                    >
                        {translate("Compare")}
                    </Checkbox>
                    
                )}
                
            </StyledWrapper> */}
               <Clickable
                                                    {...styles.productSaveCompareWrapper}
                                                    onClick={handleClick}
                                                    data-test-selector="header_signIn"
                                                >
                                                    {showIcon && <Icon size={18} src={NISCompareIcon} title={"Compare"} />}
                                                    {showLabel && <Typography {...styles.titleTypography}>{siteMessage("NIS Compare")}</Typography>}
                                                </Clickable>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
component: withProductContext(connect(mapStateToProps, mapDispatchToProps)(NISProductDeatilsProductCompare)),
definition: {
        group: "Product Details",
        displayName: "NIS Product Compare",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.showCompare,
                displayName: "Show Compare",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Both",
                        value: "both",
                    },
                    {
                        displayName: "Show Label",
                        value: "label",
                    },
                    {
                        displayName: "Show Icon",
                        value: "icon",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                sortOrder: 1,
            },
        ]
    }}
    export default widgetModule;